import { ReactNode } from "react";
import { Col, Flex, Skeleton, Span } from "@ir/ui";
import { CreditInformationLabels } from "./utils/creditInformationLabel.enum";

interface CreditDrawerInfoColProps {
  label: string;
  value?: string | number | ReactNode;
  fontBold?: boolean;
  span?: number;
  md?: number;
  isLoading?: boolean;
}

const CreditDrawerInfoCol = ({
  label,
  value,
  fontBold = true,
  span = 6,
  md = 3,
  isLoading = false,
}: CreditDrawerInfoColProps) => {
  return (
    <Col span={span} md={md} style={{ marginBottom: "27px" }}>
      <Flex className="text-grey-600 text-xs" align="center" gap={0.25}>
        <Span style={{ marginBottom: "2px" }} className="font-medium">
          {label}
        </Span>
      </Flex>
      <Flex className={`text-primary-900 ${fontBold ? "font-medium" : "font-normal"} text-sm`} align="center" gap={0.5}>
        {isLoading ? (
          <Skeleton
            height={9}
            width={label === CreditInformationLabels.Description ? 360 : 120}
            animation="wave"
            variant="rounded"
            className="mt-1 mb-2"
          />
        ) : (
          (value ?? "-")
        )}
      </Flex>
    </Col>
  );
};

export default CreditDrawerInfoCol;
